import { NAME } from './reducer'

export const getMap = (state) => state[NAME].map
export const getView = (state) => state[NAME].view
